
import React from 'react';
import { useLocation } from 'react-router-dom';
import NavLink from './NavLink';
import ResumeButton from './ResumeButton';
import { 
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu';
import { cn } from '@/lib/utils';

interface NavigationProps {
  activeSection: string;
  isHomePage: boolean;
  handleNavLinkClick: (e: React.MouseEvent<HTMLAnchorElement>, href: string) => void;
}

const Navigation: React.FC<NavigationProps> = ({ activeSection, isHomePage, handleNavLinkClick }) => {
  const location = useLocation();
  
  const primaryNavLinks = [
    { name: 'About', href: '#about' },
    { name: 'Experience', href: '#experience' },
    { name: 'Writing', href: isHomePage ? '#blog' : '/blog' },
  ];

  const moreNavLinks = [
    { name: 'Skills', href: '#skills' },
    { name: 'Personal', href: '#personal' },
    { name: 'Video', href: '#video-resume' },
    { name: 'Certifications', href: '#certifications' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <nav className="hidden md:flex items-center gap-6 lg:gap-8">
      {primaryNavLinks.map((link) => {
        const isActive = link.name === 'Writing' && location.pathname.startsWith('/blog')
          ? true
          : activeSection === link.href.substring(1);
          
        return (
          <NavLink 
            key={link.name}
            name={link.name}
            href={link.href}
            isActive={isActive}
            isHomePage={isHomePage}
            onClick={handleNavLinkClick}
          />
        );
      })}

      <NavigationMenu>
        <NavigationMenuList>
          <NavigationMenuItem>
            <NavigationMenuTrigger className="text-sm font-medium font-mono interactive-link text-muted-foreground hover:text-primary/80 h-auto px-0 py-0 bg-transparent">More</NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="grid w-[180px] gap-2 p-4">
                {moreNavLinks.map((link) => {
                  const isActive = activeSection === link.href.substring(1);
                  
                  return (
                    <li key={link.name} className="row-span-1">
                      <NavigationMenuLink asChild>
                        <a
                          href={link.href.startsWith('#') && !isHomePage ? '/' + link.href : link.href}
                          className={cn(
                            "flex select-none py-1.5 px-2 text-sm rounded-md",
                            isActive ? "text-primary bg-accent/50" : "text-muted-foreground hover:bg-muted"
                          )}
                          onClick={(e) => handleNavLinkClick(e, link.href)}
                        >
                          {link.name}
                        </a>
                      </NavigationMenuLink>
                    </li>
                  );
                })}
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>

      <ResumeButton />
    </nav>
  );
};

export default Navigation;
